module.exports = __webpack_public_path__ + "img/root001.c512aeee.png";